<app-pet-modal [(isOpen)]="isPetModalVisible" (success)="fetchPets(0)" />
<app-card title="Início" styleClass="mb-4">
  <h3 class="text-xl md:text-2xl text-gray-400">{{ userMessage() }}</h3>
</app-card>
<app-card
  title="Meus Pets"
  [isLoading]="isPetCardLoading()"
  class="mb-4"
  styleClass="mb-4"
>
  <p-button
    card-button
    icon="pi pi-plus"
    styleClass="font-semibold"
    label="Adicionar Pet"
    type="button"
    (click)="onOpenPetModal()"
  />
  <div>
    <div class="flex justify-center md:justify-start flex-wrap gap-4 w-full">
      @for(pet of pets(); track pet.id) {
      <app-pet-card [pet]="pet" (selected)="onSelectPet($event)" />
      } @empty {
      <div
        class="h-[400px] w-full bg-gray-100 mt-4 p-4 rounded-lg font-semibold flex justify-center items-center text-gray-400"
      >
        Nenhum registro encontrado
      </div>
      }
    </div>
    @if(pets().length) {
    <div class="mt-auto" paginator>
      <p-paginator
        [rows]="10"
        [totalRecords]="totalPets()"
        (onPageChange)="onPageChange($event)"
        styleClass="mt-4"
      ></p-paginator>
    </div>
    }
  </div>
</app-card>
<app-user-pet-location class="w-full mb-16 mt-16" [userId]="user()?.id ?? ''" />
